import React, { PureComponent } from 'react';
import { IPart } from 'types';
import AutoComplete from 'ui/form/auto-complete';
// Components

interface PartSelectProps {
  selected: string;
  clearOnSelect: boolean;
  label?: string;
  className?: string;
  onSelect: (partKey: string) => void;
}
export default class PartSelect extends PureComponent<PartSelectProps> {
  static defaultProps = {
    label: 'Parts',
    selected: []
  };
  handleSelect = data => {
    if (data && data.value) {
      this.props.onSelect(data.value);
      if (this.props.clearOnSelect) this.autocomplete.clear();
    }
  };
  render() {
    const { parts, selected, label, className } = this.props;

    return (
      <AutoComplete
        ref={ref => (this.autocomplete = ref)}
        className={className}
        value={selected}
        onChange={this.handleSelect}
        label={label}
        dataSet={parts.map(part => ({
          value: part.key,
          image: part.image,
          text: part.name,
          faded: part.description
        }))}
      />
    );
  }
}
